export default __webpack_public_path__ + "static/beams-053fe9e1d95b40d95749650f2a46d6ad.mp4";